import React, { IframeHTMLAttributes, useContext, useEffect, useRef } from "react";
import { BaseActivityProps } from "../Activity/Activity.component";
import {
  Container,
  StorylineIframe,
  StorylineIframeContainer,
  StorylineTitleContainer,
} from "./ActivityStoryline.style";
import { ActivityStoryline } from "../../types";
import { observer } from "mobx-react";
import { StoreContext } from "../../context";
import Title from "../Title/Title.component";
import { useState } from "react";
import { isMobile, isPortrait } from "../../utils";

interface Props extends BaseActivityProps {
  activity: ActivityStoryline;
}

const ActivityStorylineContainer: React.FC<Props> = (props) => {
  const { core } = useContext(StoreContext);
  const ref = useRef<HTMLDivElement>(null);

  const [titleContainerHeight, setTitleContainerHeight] = useState(0);

  if (props.activity.tracking?.successCondition === "open") {
    core.setInteractionResult(props.activity.id, "correct");
  }
  useEffect(() => {
    if (titleContainerHeight === 0) {
      setTitleContainerHeight(ref.current ? ref.current.offsetHeight : 0);
    }
  }, [ref]);

  return (
    <Container className="activity-storyline-container">
      {props.activity.title && (
        <StorylineTitleContainer ref={ref} className="storyline-title-container">
          <Title level={2}>{props.activity.title}</Title>
        </StorylineTitleContainer>
      )}
      <StorylineIframeContainer titleHeight={titleContainerHeight} className="storyline-iframe-container">
        {isMobile() && isPortrait() && props.activity.mobileUrl && (
          <StorylineIframe title={props.activity.title} allowFullScreen={true} src={props.activity.mobileUrl} />
        )}

        {!isMobile() ||
          (!props.activity.mobileUrl && (
            <StorylineIframe title={props.activity.title} allowFullScreen={true} src={props.activity.desktopUrl} />
          ))}
      </StorylineIframeContainer>
    </Container>
  );
};

export default observer(ActivityStorylineContainer);
